import React, { useEffect, useState } from 'react';
import { useEventTracking } from '../hooks/useAnalytics';
import ReCAPTCHA from 'react-google-recaptcha';
import API from '../api';
import './ContattiPage.css';

const ContattiPage = () => {
  const { trackEvent } = useEventTracking();
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    oggetto: '',
    messaggio: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [captchaToken, setCaptchaToken] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    trackEvent('contatti_page_view', {
      page_title: 'Contatti',
      page_location: '/contatti',
      page_type: 'contact'
    });
  }, [trackEvent]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!captchaToken) {
      setSubmitStatus('recaptcha_error');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await API.post('/contacts', {
        ...formData,
        captchaToken
      });
      
      if (response.data.success) {
        setSubmitStatus('success');
        setFormData({ nome: '', email: '', oggetto: '', messaggio: '' });
        setCaptchaToken('');
        setMessage('');
        trackEvent('contact_form_submit', {
          form_type: 'contact',
          page_location: '/contatti',
          status: 'success'
        });
      }
    } catch (error) {
      console.error('Errore nell\'invio del form:', error);
      setMessage(error.response ? error.response.data.message : 'Errore di rete');
      if (error.response && error.response.data.message === 'reCAPTCHA non valido') {
        setSubmitStatus('recaptcha_error');
        setCaptchaToken('');
      } else {
        setSubmitStatus('error');
      }
      trackEvent('contact_form_submit', {
        form_type: 'contact',
        page_location: '/contatti',
        status: 'error'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="contatti-page">
      {/* Hero Section */}
      <section className="contatti-hero">
        <div className="main-content-container">
          <div className="contatti-hero-content">
            <h1 className="contatti-hero-title">Contatti</h1>
            <p className="contatti-hero-subtitle">
                Loverlist è il comparatore di prezzi gestito da Malianta srl.
            </p>
            <p className="contatti-hero-subtitle">
                La nostra missione è aiutare i consumatori a trovare i migliori prezzi confrontando le offerte di migliaia di negozi online, garantendo trasparenza e risparmio nella scelta dei prodotti.
            </p>
          </div>
        </div>
      </section>



      {/* Informazioni di contatto */}
      <section className="contatti-info-section-main">
        <div className="main-content-container">
          <h2 className="contatti-section-title">Informazioni di contatto</h2>
          
          <div className="contatti-info-grid">
            <div className="contatti-info-item">
              <div className="contatti-info-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <div className="contatti-info-content">
                <h3 className="contatti-info-title">Email</h3>
                <p className="contatti-info-text">info@loverlist.it</p>
              </div>
            </div>

            <div className="contatti-info-item">
              <div className="contatti-info-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <div className="contatti-info-content">
                <h3 className="contatti-info-title">Sede legale</h3>
                <p className="contatti-info-text">Malianta srl</p>
                <p className="contatti-info-text">P.IVA 10412320961</p>
                <p className="contatti-info-text">Via Bastione</p>
                <p className="contatti-info-text">98057 Milazzo, Italia</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Form di contatto - spostato in basso */}
      <section className="contatti-form-section-main">
        <div className="main-content-container">
          <div className="contatti-form-container">
            <h2 className="contatti-section-title">Invia un messaggio</h2>

            <form className="contatti-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="nome" className="form-label">Nome completo *</label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  className="form-input"
                  placeholder="Il tuo nome"
                  value={formData.nome}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email" className="form-label">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-input"
                  placeholder="la-tua-email@esempio.com"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="oggetto" className="form-label">Oggetto *</label>
                <select 
                  id="oggetto" 
                  name="oggetto" 
                  className="form-select" 
                  value={formData.oggetto}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Seleziona un oggetto</option>
                  <option value="supporto">Supporto tecnico</option>
                  <option value="partnership">Partnership commerciale</option>
                  <option value="integrazione">Integrazione venditori</option>
                  <option value="generale">Informazioni generali</option>
                  <option value="altro">Altro</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="messaggio" className="form-label">Messaggio *</label>
                <textarea
                  id="messaggio"
                  name="messaggio"
                  className="form-textarea"
                  rows="6"
                  placeholder="Scrivi il tuo messaggio qui... (minimo 10 caratteri)"
                  value={formData.messaggio}
                  onChange={handleInputChange}
                  required
                ></textarea>
                <div className="form-character-count">
                  {formData.messaggio.length < 10 ? (
                    <span className="character-count-error">
                      Almeno {10 - formData.messaggio.length} caratteri rimanenti
                    </span>
                  ) : (
                    <span className="character-count-success">
                      {formData.messaggio.length} caratteri
                    </span>
                  )}
                </div>
              </div>

              <div className="form-group">
                <div className="contatti-captcha">
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                    onChange={(token) => setCaptchaToken(token)}
                  />
                </div>
              </div>

              <button 
                type="submit" 
                className="contatti-submit-btn"
                disabled={isSubmitting || !captchaToken}
              >
                {isSubmitting ? 'Invio in corso...' : 'Invia messaggio'}
              </button>
            </form>

            {/* Message box spostato in basso */}
            {submitStatus === 'success' && (
              <div className="contatti-success-message">
                <p>Grazie per averci contattato! Ti risponderemo il prima possibile.</p>
              </div>
            )}
            
            {submitStatus === 'error' && (
              <div className="contatti-error-message">
                <p>Errore di rete</p>
              </div>
            )}
            
            {submitStatus === 'recaptcha_error' && (
              <div className="contatti-error-message">
                <p>Completa il reCAPTCHA.</p>
              </div>
            )}

            {message && (
              <div className="contatti-error-message">
                <p>{message}</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContattiPage; 